import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectService } from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import { Project } from '../../../../project-misc/data/project/project';
import { ReportsFilter, ReportsService } from 'projects/app-misc/src/app/modules/reports/data/reports.service';
import { CabsProjReport } from 'projects/app-misc/src/app/modules/reports/data/cabinets-report-page';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { OrderFilter } from 'projects/desktop/src/app/modules/order/data/orders.service';
import {
  PdfPreviewDialogComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import * as moment from 'moment/moment';
import { MatDialog } from '@angular/material/dialog';
import { SystemReportsQuery } from 'projects/app-misc/src/app/modules/reports/data/system-reports.query';
import { SystemReportsStore } from 'projects/app-misc/src/app/modules/reports/data/system-reports.store';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';

@Component({
  selector: 'app-cabinet-reports-view',
  templateUrl: './cabinet-reports-view.component.html',
  styleUrls: ['./cabinet-reports-view.component.scss']
})
@RxJSUnsubscribe
export class CabinetReportsViewComponent implements OnInit, OnDestroy, RxJSUnsubscribable {
  allProjs: Project[]
  selectedProjs: Project

  openedReports = []

  complexReports: CabsProjReport[];

  reportsLoading: boolean

  totalRecords: number;

  searchString = '';

  loadSubj = new Subject<void>();

  repElemsCount = 15;

  reportsFilter: ReportsFilter = {};

  projSearchSubj: Subscription;

  constructor(
    private dialog: MatDialog,
    public router: Router,
    private projectsService: ProjectService,
    private reportsService: ReportsService,
    protected systemReportsQuery: SystemReportsQuery,
    protected systemReportsStore: SystemReportsStore
  ) {
  }

  ngOnInit(): void {
    this.projSearchSubj = this.systemReportsQuery.searchQuery$.pipe(takeUntil(this.getUnsubFromAllSubs())).subscribe(query => {
      if(query !== '') {
        this.searchString = query
        this.systemReportsStore.updateSearchQuery('')
        this.reportsFilter.query = this.searchString;

        this.reportsLoading = true;

        this.reportsFilter.start = 0;
        this.reportsFilter.limit = this.repElemsCount;

        this.reportsService.getCabinetReports(this.reportsFilter).subscribe(reps => {
          this.complexReports = reps.content
          this.totalRecords = reps.totalElements;

          this.reportsLoading = false;

          this.openedReports = [0]
        })

      }
    })

    if(this.searchString === '') {
      this.getReportsLazy(0, this.repElemsCount)
    }

    this.subToSearch();
  }

  subToSearch() {
    this.loadSubj.pipe(debounceTime(500)).subscribe(emit => {
      this.reportsFilter.query = this.searchString;
      this.getReportsLazy(0, this.repElemsCount)
    })
  }

  topSearchBar() {
    this.loadSubj.next()
  }

  getReportsLazy(page: number, rows: number) {
    this.openedReports = [];
    this.reportsLoading = true;

    this.reportsFilter.start = page;
    this.reportsFilter.limit = rows;

    this.reportsService.getCabinetReports(this.reportsFilter).subscribe(reps => {
      this.complexReports = reps.content
      this.totalRecords = reps.totalElements;

      this.reportsLoading = false;
    })
  }

  updateDate(eventData) {

  }

  openProjReport(event) {

  }

  closeProjReport(event) {

  }

  createReport(complexReport: CabsProjReport, event) {
    const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: `${complexReport.project.name} complexity report`,
        link: `/cabinets-complexity/list/reports/pdf?projectId=${complexReport.project.id}`,
        showSendButton: false

      },
      panelClass: 'pdf-preview-dialog'
    });
  }

  resetSearch() {
    this.searchString = '';
    this.reportsFilter.query = '';
    this.getReportsLazy(0, this.repElemsCount)
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

  ngOnDestroy() {
  }
}
